import { useNavigate } from 'react-router-dom'
import { Introduction } from '@joinomu/ui'

export function PatientOnboardingIntroduction() {
  const navigate = useNavigate()

  const handleStart = () => {
    navigate('/patient/onboarding')
  }

  const handleSignInClick = () => {
    navigate('/patient/login')
  }

  return (
    <Introduction
      onStart={handleStart}
      onSignInClick={handleSignInClick}
      progress={0}
    />
  )
}